<div class="questionnaire-tag-layout">
  <div *ngFor="let item of questionnaireTagArray;let i = index" class="questionnaire-tag-elem elem-{{i}}" (click)="selectTag(i)">{{item.description}}</div>
</div>



// WEBPACK FOOTER //
// ./src/component/questionnire/child-tag/component.questionnaire-tag.html